import { api } from 'common';

import { MirthFormFields } from './FormFields';
import { MirthMessageType, mirthDefaultMessages } from './constants';
import { MirthDocumentationMarkdown } from './documentation';
import { CodeMirrorLanguageType } from '../../../../Code/types';
import { type BlockConfigProps } from '../../types';

export const mirthBlockConfig: BlockConfigProps<api.FlowDefinition.MirthBlockConfig> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'interfaceEngine',
  defaultConfig: {
    message: mirthDefaultMessages[MirthMessageType.X12],
    path: '/',
    messageType: MirthMessageType.X12,
    timeout: {
      units: api.FlowDefinition.DurationUnits.Seconds,
      value: '45',
    },
  },
  configFields: {
    getLanguageFieldValues: (config) => {
      return {
        [CodeMirrorLanguageType.DoubleBraceNodeFields]: [config.message, config.path],
      };
    },
    schema: api.FlowDefinition.MirthBlockConfigSchema,
    FormFields: MirthFormFields,
  },
  documentationMarkdown: MirthDocumentationMarkdown,
};
